import React from "react";
import AntdTag, {TagProps} from "antd/lib/tag";
import {withError} from '@fishx/tracker';

const CheckableTag = AntdTag.CheckableTag;
interface TProps extends React.FC<TagProps> {
  CheckableTag: typeof CheckableTag;
}
export const Tag: TProps = (props) => {
  return <AntdTag {...props} />;
}
Tag.CheckableTag = CheckableTag;
Tag.displayName = 'Tag';
export default withError(Tag);


// WEBPACK FOOTER //
// ./src/components/tag/index.tsx